module.exports = __webpack_public_path__ + "static/media/Active_Coupons_Icon.d1dcea54.png";